<script setup lang="ts">
defineProps<{
  status: string
  currentPath: string
}>()
</script>

<template>
  <footer class="status-bar bg-card border-t border-border py-2 px-4">
    <div class="max-w-7xl mx-auto flex items-center justify-between text-sm">
      <div class="status-left">
        <span class="text-muted-foreground">{{ status }}</span>
      </div>
      <div class="status-right">
        <span class="text-muted-foreground">{{ currentPath || '根目录' }}</span>
      </div>
    </div>
  </footer>
</template>
